export default __webpack_public_path__ + "static/media/answered_icon.bf272698.svg";